import { render, staticRenderFns } from "./ManageAdd.vue?vue&type=template&id=5e66b6d1&scoped=true&"
import script from "./ManageAdd.vue?vue&type=script&lang=ts&"
export * from "./ManageAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66b6d1",
  null
  
)

export default component.exports